module.exports = __webpack_public_path__ + "img/play.83ad716d.svg";